import SellsyAccountManagerRoutes from 'routes/sellsyaccountmanager'
import Store from 'Services/Store';

export default {
    computed: {
        maxNbLicences() { return 500; },
        // STORE - getters
        countries() { return this.$store.getters.countries },
        billingLocales() { return this.$store.getters.billingLocales },
        userIsSellsy() { return this.$store.getters.userIsSellsy },
        userPermissions() { return this.$store.getters.userPermissions },
        activeStep() { return this.$store.getters.activeStep },
        stepsList() { return this.$store.getters.stepsList },

        // COMPUTED
        // - Cart
        cartItemsIterable() { return this.buildCartItemsIterable(this.cartItems) },
        savedCartItemsIterable() { return this.buildCartItemsIterable(this.savedCartItems) },
        cartItemsHashed() { return this.buildProductsHashed(this.cartItemsIterable) },
        savedCartItemsHashed() { return this.buildProductsHashed(this.savedCartItemsIterable) },
        subscribedProductsHashed() { return this.buildProductsHashed(this.subscribedProductsIterable) },
        cartTotal() { return this.buildTotal(this.cartItemsIterable, this.currentPricingPlan); },
        cartBasicProduct() { return this.getCartItem(this.pricingBasicProduct.id) },
        cartNbLicenses() { return this.cartBasicProduct ? this.cartBasicProduct.quantity : 1 },
        cartNbOfferedLicenses() { return this.cartBasicProduct && !_.isNil(this.cartBasicProduct.quantityFree) ? this.cartBasicProduct.quantityFree : 0 },
        cartHasDiscount() { return this.cartTotal.monthly.raw !== this.cartTotal.monthly.totalDiscounted },
        newItemsOnSubscriptionIterable() {
            let newItemsIterable = [];

            this.cartItemsIterable.forEach(cartItem => {
                let newItem = { ...cartItem };
                let subscribedItem = this.subscribedProductsIterable.find(subscribedProduct => subscribedProduct.product_id === cartItem.product_id);
                if (subscribedItem !== undefined) {
                    newItem.quantity -= subscribedItem.quantity;
                    newItem.customPricing -= subscribedItem.customPricing;
                    if (_.reduce([newItem.quantity, newItem.customPricing], function (memo, num) { return memo + num; }, 0) == 0) return;
                }
                newItemsIterable.push(newItem);
            });
            return newItemsIterable;
        },
        newItemsOnSubscriptionTotal() { return this.totalComputeDiffs(this.cartTotal, this.customerSubscribedTotal) },
        newItemsOnSubscriptionTotalProrated() { return this.totalProratedAmount(this.newItemsOnSubscriptionTotal, this.customerServiceEndDateObj) },
        newItemsOnSubscriptionTotalForCurrentPricingPlan() { return this.isCurrentPricingMonthly ? this.newItemsOnSubscriptionTotal[this.currentPricingPlan.toLowerCase()] : this.newItemsOnSubscriptionTotalProrated[this.currentPricingPlan.toLowerCase()] },

        // - Subscribed products
        subscribedProductsIterable() {
            let iterable = [];

            this.customerSubscribedProducts
            .filter(c => c.type == 'pack')
            .map(subscribedProduct => {
                let product = this.pricingProducts.find(product => product.code === subscribedProduct.code);

                let pricingFeeded;
                let licencesFree = 0;

                if (!_.isNil(subscribedProduct.productPlan.customPricing) && subscribedProduct.productPlan.customPricing?.length) {
                    if (this.customerSubscribedBasicProduct.id === subscribedProduct.id) {
                        pricingFeeded = subscribedProduct.productPlan.customPricing.map((pricing, pricingIndex) => {
                            let licences;
                            if (pricingIndex === 0) {
                                licences = pricing.up_to === 'inf' ? subscribedProduct.customerLicense.quantitySubscribed : pricing.up_to;
                            } else {
                                licences = pricing.up_to === 'inf' ? (subscribedProduct.customerLicense.quantitySubscribed - subscribedProduct.productPlan.customPricing[pricingIndex - 1].up_to) : (pricing.up_to - subscribedProduct.productPlan.customPricing[pricingIndex - 1].up_to);
                            }

                            if (pricing.unit_amount == 0) {
                                licencesFree = licences;
                            }

                            return {
                                ...pricing,
                                unit_amount: pricing.unit_amount,
                                nbLicences: licences
                            }
                        });
                    } else {
                        pricingFeeded = Array.isArray(subscribedProduct.productPlan.customPricing) && subscribedProduct.productPlan.customPricing.length ? subscribedProduct.productPlan.customPricing[0].unit_amount : null;
                    }
                } else {
                    pricingFeeded = null;
                }
                let item = {
                    product_id: product.id,
                    id: subscribedProduct.id,
                    quantity: (subscribedProduct.customerLicense !== null && subscribedProduct.customerLicense.quantitySubscribed !== undefined) ? subscribedProduct.customerLicense.quantitySubscribed : 1,
                    quantityFree: licencesFree,
                    customPricing: pricingFeeded,
                    product: product,
                };
                product == this.pricingBasicProduct ? iterable.unshift(item) : iterable.push(item);
            });

            return iterable;
        },
        customerSubscribedBasicProduct() { return this.getCustomerSubscribedProduct(this.pricingBasicProduct) },
        customerSubscribedBasicProductCustomPricing() { return this.customerSubscribedBasicProduct?.productPlan?.customPricing ?? [] },
        customerSubscribedLicenses() {
            if (this.customerSubscribedBasicProduct === undefined) return 0;
            return this.customerSubscribedBasicProduct.customerLicense.quantitySubscribed;
        },
        customerSubscribedLicensesOffered() {
            if (this.isCartContext('renew')) return 0;
            if (this.customerSubscribedBasicProduct === undefined) return 0;
            if (this.customerSubscribedBasicProduct.productPlan === null) return 0;
            return this.customerSubscribedBasicProduct.productPlan.customQuantityFree
        },

        // - Steps
        stepHasNextOne() { return this.breadcrumbs[this.breadcrumbs.indexOf(this.activeStep) + 1] !== undefined; },
        stepHasPreviousOne() { return this.breadcrumbs[this.breadcrumbs.indexOf(this.activeStep) - 1] !== undefined; },

        isAvailablePaymentFacility() { return this.isCurrentPricingYearly && !this.isCartContext('upsale') },
        isEditablePaymentFacility() { return this.isAvailablePaymentFacility },

        isAvailablePaymentMethod() { return this.isCurrentPricingYearly },
        isEditablePaymentMethod() { return this.isAvailablePaymentMethod },

        submitPayload() {
            // Build payload
            let payload = {
                context: this.cartContext,
                pricingVersion: this.currentPricingVersion,
                pricingRevision: this.currentPricingRevision,
                pricingPlan: this.currentPricingPlan,
                products: this.buildCartItemsForPayload(this.cartItems, this.currentPricingPlan),
                stripeToken: this.$store.getters.stripeToken,
                source: 'customer',
                ...this.customMailData
            };

            // Overwrite a specific cart
            if (this.isCartLoaded) {
                payload.cart = this.cartId;
                // Detect if cart includes changes
                switch (true) {
                    // PricingPlan
                    case !_.isEqual(this.cartPricing.plan, this.currentPricingPlan): 
                    // Products (+qty)
                    case !_.isEqual(payload.products, this.buildCartItemsForPayload(this.savedCartItems, this.cartPricing.plan)): 
                    // If user is Sellsy Sale, always generate a new cart
                    case this.userIsSellsy: 
                        payload.cartHasChanged = true;
                        break;
                    default:
                        payload.cartHasChanged = false;
                        break;
                }
            }

            if (this.userIsSellsy) {
                // Period appliance
                if (this.cartPeriodStartDate && !this.isCartContext('upsale')) payload.periodApplianceStart = this.cartPeriodStartDate;

                payload.expiredDate = this.cartExpiredDate;
                payload.earlyRenewal = this.cartEarlyRenewal;

                if (this.isEditablePaymentMethod) {
                    payload.paymentMethod = this.cartPaymentMethod;
                }

                payload.source = 'sales';

                if (this.isEditablePaymentFacility) {
                    payload.paymentFacility = this.cartPaymentFacility;
                }
            }

            return payload;
        },
        canCartBeCanceled() { return this.cartIsCancelable; },
        canCartBeSaved() {
            // Customer + neither his billing address or contact are valid
            if (!this.userIsSellsy && !(this.isAddressValid(this.billingAddress) && this.isContactValid(this.billingSettings))) return false;

            // Nothing selected
            let selectedItemsMonthlyAmount = this.cartTotal.monthly.totalDiscounted;
            if (0 >= selectedItemsMonthlyAmount) return false; 

            // No downsell allowed in upsell context
            if (this.isCartContext('upsale')) {
                // No diffs between selected and subscribed 
                if (_.isEqual(this.subscribedProductsHashed, this.cartItemsHashed)) return false;

                // If changes are made on subscription but not affect subscription total amount
                if (this.userIsSellsy && this.userHasPermission('can_edit_cart_with_no_change_on_subscription_amount') && this.cartTotal.monthly.totalDiscounted >= this.customerSubscribedTotal.monthly.totalDiscounted) return true;

                // If changes have been made by a sellsy with permission on subscription but not affect subscription total amount
                if (!this.userIsSellsy && this.isCartLoaded && this.cartTotal.monthly.totalDiscounted >= this.customerSubscribedTotal.monthly.totalDiscounted) return true;

                // The monthly total excluding VAT, which must always be higher than the current subscription amount
                if (!(this.cartTotal.monthly.totalDiscounted > this.customerSubscribedTotal.monthly.totalDiscounted)) return false;
            }

            return true;
        },
        currentPricingTotal() { return this.pricingPlanTotal(this.currentPricingPlan) },
        currentCountryTaxRate() { return this.getCountryTaxRate(this.countryCode) },
        countryTaxRate() { return this.getCountryTaxRate(this.billingAddress.country) },
        countryCode() { return !!this.billingAddressTmp ? this.billingAddressTmp.country : this.billingAddress.country },
        showTaxTotalInForm() { return this.isTaxTotalShouldBeDisplay(this.billingAddressTmp.country, '') },
        showTaxTotal() { return this.isTaxTotalShouldBeDisplay(this.billingAddress.country, this.billingSettings.vatIdentificationNumber) },
        billingSettingsHasChanged() {
            // Vat identifier number
            if (this.billingAddressTmp.vatIdentificationNumber !== this.billingSettings.vatIdentificationNumber) return true;
            return false;
        },
        frenchCountriesWithVat() {
            return [
                { country: 'FR', rate: 0.2 },
                { country: 'MC', rate: 0.2 },
                { country: 'MQ', rate: 0.085 },
                { country: 'GP', rate: 0.085 },
                { country: 'RE', rate: 0.085 },
            ]
        },
        urlToCartPublicCheckout() { return this.buildUrlToCartPublicCheckout(this.cartId) },
        urlToCustomerThirdOverview() { return this.$router.resolve({ name: 'third.overview.samCarts', params: { type: 'client', id: this.customer.saasThirdId } }).href},
        urlCartSale() { return this.getUrlCartSale() },
        urlCartSaleWithCart() { return this.getUrlCartSale(true) },
        userIsLogged() {
            const corpId = Store.get('corp').id;
            if (!corpId) return false;
            if (corpId != this.customerCorporation) return false;
            return true;
        },
        currencySymbol() { return App.numformat.currencysymbol },
        paymentMethodsOptions() {
            return [{
                label: this.$l10n.__('Carte bancaire'),
                value: 'stripe_card'
            }, {
                label: this.$l10n.__('Virement'),
                value: 'manual'
            }]
        },
    },
    methods: {
        getUrlCartSale(withCart) { return this.buildUrlCartSale(this.customerCorporation, !!withCart ? this.cartId : undefined) },
        buildUrlToCartPublicCheckout(cartId) { 
            let route = SellsyAccountManagerRoutes.find(route => route.name == 'sam.selfservice.cart.checkout')
            return this.buildRoute(route, [{ key: 'id', value: cartId }])
        },
        buildUrlCartSale(corporation, cartId) { 
            let route = SellsyAccountManagerRoutes.find(route => route.name == 'sam.cart.form')
            return this.buildRoute(route, [{ key: 'id', value: corporation }]) + (!!cartId ? "?id=" + cartId : '') 
        },
        // Store setters
        setCountries(data) { return this.$store.dispatch('defineCountries', data) },
        setBillingLocales(data) { return this.$store.dispatch('defineBillingLocales', data) },
        setUserAsSellsy(data) { return this.$store.dispatch('defineUserAsSellsy', data) },
        setUserPermissions(data) { return this.$store.dispatch('defineUserPermissions', data) },
        // - Steps
        nextStep() { return this.$store.dispatch(`nextStep`) },
        previousStep() { return this.$store.dispatch(`previousStep`) },
        goToStep(id) { return this.$store.dispatch('goToStep', id) },

        // getters
        // - Country
        getCountryFromCode(code) { 
            if (code === undefined || code === null) return {} 
            return this.getCountryObjectFromProp('code', code.toUpperCase())
        },
        getCountryFromName(name) { return this.getCountryObjectFromProp('name', name) },
        getCountryObjectFromProp(prop, value) { return this.countries.find(c => c[prop] === value) || {} },
        hasCountryIntraVat(code) { return this.getCountryFromCode(code).hasTvaIntra === 'Y' },
        isFrenchCountry(code) { return undefined !== this.frenchCountriesWithVat.find(country => country.country == code.toUpperCase()) },
        // - Country
        getBillingLocaleFromCode(code) { 
            if (code === undefined || code === null) return {} 
            return this.getBillingLocaleObjectFromProp('code', code.toUpperCase())
        },
        getBillingLocaleObjectFromProp(prop, value) { return this.billingLocales.find(c => c[prop] === value) || {} },

        formatAmount(amount, withDecimals, withCurrency) { return this.$options.filters.numberformatWithOptions(amount, { 'precision': !!withDecimals ? 2 : 0 }, (withCurrency === undefined || withCurrency)) },
        formatDate(date, showRelativeDate, withTime) { return this.$options.filters.dateFormatter(moment(date).unix(), !!withTime ? 'NORMAL_DATE_TIME' : 'NORMAL_DATE', !!showRelativeDate) },

        // - Rate
        getCountryTaxRate(code) {
            let country = this.getCountryFromCode(code);
            if (_.isEmpty(country)) return 0;

            let countryVat = this.frenchCountriesWithVat.find(vat => vat.country.toUpperCase() === country.code.toUpperCase());
            if (countryVat !== undefined) {
                return countryVat.rate;
            }
            return country.hasTvaIntra === 'Y' ? 0.2 : 0;
        },
        isTaxTotalShouldBeDisplay(country, vatIdentifier) {
            if (country === null) { return false }
            return this.isFrenchCountry(country) || (this.hasCountryIntraVat(country) && !vatIdentifier)
        },

        // COMPUTED METHODS
        // - Build object with product id as key
        buildCartItemsForPayload(items, pricingPlan) {
            let selectedProducts = {};

            items.forEach(item => {
                let productId = item.product_id || item.product.uuid;
                let product = this.pricingProducts.find(c => c.id == productId);
                // if customPricing is different from the default pricing
                selectedProducts[item.product_id] = {
                    quantity: { subscribed: !_.isNil(item.customPricing) && Array.isArray(item.customPricing) ? item.customPricing.map(price => price.nbLicences).reduce((acc, value) => acc + value) : item.quantity },
                    customPricing: (item.customPricing !== null && item.customPricing !== undefined) && item.customPricing !== this.getProductAmount(product, pricingPlan, false)
                        ? Array.isArray(item.customPricing) ? item.customPricing.filter(pricing => pricing.up_to !== 0).map(({up_to, unit_amount }) => { return { up_to, unit_amount } }) : [{up_to: 'inf', unit_amount: item.customPricing}]
                        : null,
                };
            });

            return selectedProducts;
        },
        buildCartItemsIterable(cartItems) {
            return cartItems.map(item => {
                item.product = this.pricingProducts.find(product => product.id === item.product_id);
                return item;
            })
        },

        // - Cart validator for products
        arePricingProductsCompliantAsCartItems() {
            let errors = {
                mandatory: [],
                quantityMinimum: []
            };

            // iterate on every products (regardless of those in the cart) for checking if:
            // - mandatory products are checked
            // - min qty is compliant
            this.pricingProducts.map((product) => {
                // get current plan
                let plan = this.getProductPlan(product, this.currentPricingPlan);
                if (plan === undefined) return;

                // is mandatory && !contains in cart items
                if (plan.mandatory && !this.getCartItem(product.id)) {
                    errors.mandatory.push(product.printableName);
                }
                // has minimum quantity && contains in cart items && qty is lower that min accepted
                if (plan.quantityMinimum && this.getCartItem(product.id) && this.tmpNbLicenses < plan.quantityMinimum) {
                    errors.quantityMinimum.push({
                        name: product.printableName,
                        quantity: plan.quantityMinimum
                    });
                }
            });

            // Print missing mandatory products
            if (errors.mandatory.length) {
                Push.error(this.$l10n.n__('L\'application %(productsName)s est requise', 'Les applications %(productsName)s sont requises', errors.mandatory.length, {
                    'productsName': errors.mandatory.join(', ')
                }));
            }

            // Print minimum quantity not respected
            if (errors.quantityMinimum.length) {
                errors.quantityMinimum.map(product => {
                    Push.error(this.$l10n.__('La quantité requise pour %(productName)s est de %(quantity)s', {
                        'productName': product.name,
                        'quantity': product.quantity
                    }));
                })
            }

            return !(errors.mandatory.length || errors.quantityMinimum.length);
        },

        /**
         * 
         * @param {*} product 
         * @returns product
         */
        toggleItem(product) {
            if (product === undefined) return;

            /**
             * Product is a grouped optional item, we must check if an another item of his group is set to replace it.
             */
            if(!!product.groups.length) {
                const itemInCart = this.getCartGroupItem(product.groups[0]);
                // No Group's item at all, add it !
                if (!itemInCart) return this.addCartItem(product.id, null, this.getProductAmount(product, this.currentPricingPlan));

                // Product is the same in cart, remove it.
                if (itemInCart.product_id === product.id) {
                    return this.removeCartItem(product.id)
                } else {
                    // Products are different, replace it with new product !
                    this.removeCartItem(itemInCart.product_id);
                    this.addCartItem(product.id, null, this.getProductAmount(product, this.currentPricingPlan));
                    return;
                }
            }

            // Single Product
            if (!this.getCartItem(product.id)) {
                return this.addCartItem(
                    product.id,
                    null,
                    this.getProductAmount(product, this.currentPricingPlan)
                )
            } else {
                return this.removeCartItem(product.id);
            }
        },

        // - Cart product management checkers
        canProductBeToggled(product, isLicence) { 
            return !!this.getCartItem(product.id) ? this.canProductBeUnselected(product, isLicence) : this.canProductBeSelected(product); 
        },
        canProductBeUnselected(product, isLicence) {
            // renew + sellsy user can unselect
            if (this.isCartContext('renew') && this.userIsSellsy) return true;
            // sellsy user can unselect in any case if has permiossion to edit cart with no MRR increase
            if (this.userIsSellsy && this.userHasPermission('can_edit_cart_with_no_change_on_subscription_amount')) return true;
            // subscribed can't be unselected
            if (!isLicence && this.getCustomerSubscribedProduct(product)) return false;
            // sellsy user can unselect
            if (this.userIsSellsy) return true;
            // cart loaded + product is saved in cart + cart has discount
            if (this.isCartLoaded && this.getCartItemSaved(product.id) && !isLicence) return false;

            return true;
        },
        canProductBeSelected(product) { return true },

        // - Amount getters
        getProductMonthlyAmount(product, planCode, withCustomPricing, forcedCustomPricing) {
            if (!product) return 0;
            let amount = false;

            if (withCustomPricing == undefined || withCustomPricing) {
                if (forcedCustomPricing !== undefined && Number.isInteger(parseInt(forcedCustomPricing))) {
                    amount = forcedCustomPricing
                } else {
                    let cartItem = this.getCartItem(product.id);
                    if (cartItem && !_.isNil(cartItem.customPricing)) amount = cartItem.customPricing;
                }
            }
            if (amount === false) amount = this.getProductAmount(product, planCode, false);
            return amount;
        },
        getProductYearlyAmount(product, planCode, withCustomPricing) { return this.getProductMonthlyAmount(product, planCode, withCustomPricing) * 12; },
        pricingPlanUnit() { return this.getPricingPlanUnit(this.currentPricingPlan); },

        otherPricingPlan() { return this.pricingPlans.find(plan => plan.plan !== this.currentPricingPlan).plan },
        otherPricingPlanUnit() { return this.getPricingPlanUnit(this.otherPricingPlan); },

        // - Licences update
        updateNbLicenses(licenses) {
            this.tmpNbLicenses = licenses;
            this.updateCartItemQuantity(this.pricingBasicProduct.id, licenses);
        },
        updateNbFreeLicences(licenses) {
            this.tmpNbLicensesOffered = licenses;
            this.updateCartItemQuantityOffered(this.pricingBasicProduct.id, licenses);
        },

        // - Pricing changes
        switchPricingPlan(plan) {
            if (this.currentPricingPlan == plan) return;
            this.setCurrentPricingPlan(plan);
        },
        switchCartItemPricing(planCode) {
            if (this.currentPricingPlan === planCode) {
                return;
            }

            [...this.pricingOptionalProducts, ...this.pricingOptionalProductsGrouped].forEach(product => {
                const cartItem = this.getCartItem(product.id);
                if (!cartItem) return;

                let newAmount = null;
                if (!_.isNil(cartItem.customPricing)) {
                    newAmount = planCode === 'MONTHLY' ? cartItem.customPricing / 12 : cartItem.customPricing * 12;

                    // When Previous pricing is the max price plan, keep max price in other plan
                    if(cartItem.product.plans.find(plan => plan.code === this.currentPricingPlan).amountInCents === cartItem.customPricing) {
                        newAmount = cartItem.product.plans.find(plan => plan.code === planCode).amountInCents;
                    }
                }
                this.updateCartItemCustomPricing(product.id, newAmount);
            })
        },
        pricingPlanTotal(plan) { return this.cartTotal[plan.toLowerCase()] || {} },

        buildProductsHashed(iterable) {
            let hashed = [];
            iterable.forEach(i => hashed.push([i.product.code, i.quantity, i.quantityFree || 0, Array.isArray(i.customPricing) ? i.customPricing.map(price => [price.up_to, price.unit_amount, price.nbLicences] ).flat() : i.customPricing].join(':')))
            return hashed;
        },

        // - Load cart from id
        loadCart(corporation, id) {
            return this.getCart(corporation, id)
                .then((cart) => {
                    // if error when retrieve, throw it
                    if (cart.error) throw new Error('cart_load_error')
                    return this.feedFormFromCart(cart);
                });
        },
        loadFromCart(cart) {
            // if error when retrieve, throw it
            if (cart.error) throw new Error('cart_load_error')
            return this.feedFormFromCart(cart);
        },
        feedFormFromCart(cart) {
            cart.items = cart.items.map((item, index) => {
                let pricingFeeded;

                if (!_.isNil(item.customPricing) && item.customPricing?.length ) {
                    if(index === 0 ) {
                        pricingFeeded = item.customPricing.map((pricing, pricingIndex) => {
                            let licences;
                            if (pricingIndex === 0) {
                                licences = pricing.up_to === 'inf' ? item.quantity : pricing.up_to;
                            } else {
                                licences = pricing.up_to === 'inf' ? (item.quantity - item.customPricing[pricingIndex - 1].up_to) : (pricing.up_to - item.customPricing[pricingIndex - 1].up_to);
                            }
                            return {
                                ...pricing,
                                unit_amount: pricing.unit_amount,
                                nbLicences: licences
                            }
                        });
                    } else {
                        pricingFeeded = Array.isArray(item.customPricing) && item.customPricing.length ? item.customPricing[0].unit_amount : null;
                    }
                } else {
                    pricingFeeded = null;
                }
                return {
                    ...item,
                    product_id: item.product,
                    quantity: item.quantity || 1,
                    customPricing: pricingFeeded,
                    quantityFree: this.pricingBasicProduct.id === item.product && item.customPricing && !_.isNil(item?.customPricing.find(pricing => pricing.unit_amount === 0)) ? item.customPricing.find(pricing => pricing.unit_amount === 0).up_to : 0
                };
            });

            return new Promise(async (resolve, reject) => {
                // Add each already selected items in cart widget
                
                // save inital items content
                this.setSavedCartItems(cart.items);
                // set cart data in store + define current pricing
                resolve(Promise.all([
                    // set cart in store
                    this.setSavedCart(cart),
                    this.setCart(cart),
                    // define current pricing from cart
                    this.setCurrentPricingVersion(cart.pricingVersion),
                    this.setCurrentPricingRevision(cart.pricingVersionRevision),
                    this.setCurrentPricingPlan(cart.pricingPlanId),
                    this.setCartPaymentMethod(cart.paymentMethod),
                    this.setCartPaymentFacility(cart.paymentFacility),
                    this.setCartPeriodStart(cart.periodApplianceStart),
                    this.setCartPeriodStop(cart.periodApplianceStop),
                    this.setCartExpiration(cart.expirationDate),
                    this.setCartEarlyRenewal(cart.earlyRenewal),
                    this.setCartEarlyRenewalDiscount(cart.creditNoteAmount),
                    this.setCartContactAdded(cart.contactAdded),
                    this.setCartContactMailAddress(cart.contactMailAddress),
                    this.setCartContactName(cart.contactName),
                    this.setCartContactPhone(cart.contactPhone),
                ]));
            });
        },

        // FORM FEED
        feedFormWithCart() {
            if (!this.cart) {
                return this.feedFormWithCustomer();
            }
            return this.feedFormFromCart(this.cart);
        },
        feedFormWithCustomer() {
            if (!this.billingSettings.stripeSubscription) return this.feedFormWithDefault();
            return Promise.all([
                this.setCurrentPricingVersion(this.billingSettings.pricingVersion),
                this.setCurrentPricingRevision(this.billingSettings.pricingVersionRevision),
                this.setCurrentPricingPlan(this.billingSettings.pricingPlanCode),
                this.setCartPaymentMethod(this.billingSettings.paymentMethod),
                this.setCartPeriodStart(this.billingSettings.serviceEndDate),
                this.setCartPeriodStop(moment(this.billingSettings.serviceEndDate).add(12, 'month').toISOString()),
            ]).then(() => {
                let items = [];
                let customerSubscribedProductsHydrated = this.customerSubscribedProducts;
                this.customerSubscribedProducts.forEach((subscribed, subIndex) => {
                    let product = this.pricingProducts.find(c => c.code == subscribed.code);
                    if (product == undefined) return;

                    let pricingFeeded;

                    if ((!this.isCartContext('renew') || this.userIsSellsy) && !_.isNil(subscribed.productPlan.customPricing) && subscribed.productPlan.customPricing?.length) {
                        if (this.customerSubscribedBasicProduct.id === subscribed.id) {
                            pricingFeeded = subscribed.productPlan.customPricing.map((pricing, pricingIndex) => {
                                let licences;
                                if (pricingIndex === 0) {
                                    licences = pricing.up_to === 'inf' ? subscribed.customerLicense.quantitySubscribed : pricing.up_to;
                                } else {
                                    licences = pricing.up_to === 'inf' ? (subscribed.customerLicense.quantitySubscribed - subscribed.productPlan.customPricing[pricingIndex - 1].up_to) : (pricing.up_to - subscribed.productPlan.customPricing[pricingIndex - 1].up_to);
                                }
                                return {
                                    ...pricing,
                                    unit_amount: pricing.unit_amount,
                                    nbLicences: licences
                                }
                            });
                        } else {
                            pricingFeeded = Array.isArray(subscribed.productPlan.customPricing) && subscribed.productPlan.customPricing.length ? subscribed.productPlan.customPricing[0].unit_amount : null;
                        }
                    } else {
                        pricingFeeded = null;
                    }

                    items.push({
                        product_id: product.id,
                        id: subscribed.id,
                        quantity: null !== subscribed.customerLicense ? subscribed.customerLicense.quantitySubscribed : 1,
                        customPricing: pricingFeeded,
                        quantityFree: ((!this.isCartContext('renew') || this.userIsSellsy) && null !== subscribed.productPlan && null !== subscribed.productPlan.customQuantityFree)
                            ? subscribed.productPlan.customQuantityFree
                            : 0
                    });
                    customerSubscribedProductsHydrated[subIndex] = {
                        ...subscribed,
                        customPricing: pricingFeeded
                    };
                });
                // save inital items content
                this.setCustomerSubscribedProducts(customerSubscribedProductsHydrated);
                this.setSavedCartItems(items);
            }).catch((e) => this.feedFormWithDefault())
        },
        feedFormWithDefault() {
            return Promise.all([
                this.setCurrentPricingVersion(this.cartMetadata.currentPricingVersion),
                this.setCurrentPricingRevision(this.cartMetadata.currentPricingVersionRevision),
                this.setCartPaymentMethod('stripe_card'),
            ])
            .then(() => this.addCartItem(this.pricingBasicProduct.id, 2, null, 0))
        },

        createPaymentIntentForCart(cartid) {
            return this.createCartPaymentIntent(cartid)
            .then((paymentIntent) => Promise.all([
                this.setCartPaymentIntent(paymentIntent),
                this.setCartPaymentIntentTotal(this.buildTotalFromPaymentIntentAmount(paymentIntent))
            ]));
        },

        buildTotalFromPaymentIntentAmount(paymentIntent) {
            let total = {
                amount: null,
                tax: null,
                taxIncluded: null,
                paymentFacility: this.cartPaymentFacility > 1 ? paymentIntent.amount : null,
            };
            total.taxIncluded = !!total.paymentFacility ? total.paymentFacility * this.cartPaymentFacility : paymentIntent.amount;
            total.amount = this.showTaxTotal ? total.taxIncluded / (1 + this.countryTaxRate) : total.taxIncluded
            total.tax = total.taxIncluded - total.amount;
            return total;
        },
        buildFacilityAmounts(totalAmountVatIncludedPerYear, nbFacility) {
            let unitAmount = parseInt(totalAmountVatIncludedPerYear / nbFacility, 10);
            let restAmount = totalAmountVatIncludedPerYear - unitAmount * nbFacility;
            let firstAmount = unitAmount + restAmount;
            return {
                firstAmount: firstAmount,
                nextAmount: unitAmount,
            }
        },
        buildCustomFacilityAmounts(totalAmountVatIncludedPerYear, paymentFacility) {
            let strPaymentFacility = new String(paymentFacility);
            let nbFacility = parseInt(strPaymentFacility.substring(1, 3), 10);
            let firstFacilitiesFactor = parseInt(strPaymentFacility.substring(3, 5), 10);

            let monthlyAmountDue = parseInt(totalAmountVatIncludedPerYear / 12, 10);
            
            let nbFirstFacilities = nbFacility - 1;
            let firstAmount = monthlyAmountDue * firstFacilitiesFactor;
            let lastAmount = totalAmountVatIncludedPerYear - (firstAmount * nbFirstFacilities)

            return {
                nbFirstFacilities: nbFirstFacilities,
                firstAmount: firstAmount,
                lastAmount: lastAmount,
            }
        },
        // CART RECORD
        saveCart(callback, asDraft) { return window.EventBus.$emit('savecart', callback, !!asDraft) },
        saveDraftCart(callback) { return this.saveCart(callback, true) },
        userHasPermission(permission, defaultValue) {
            return this.userPermissions[permission] 
                ?? defaultValue 
                ?? false
        },
        defineQuantityAppliedForEachPricingTier(customPricing, quantity) {
            if (undefined == customPricing || customPricing.length == 0) return customPricing

            return customPricing.map((pricing, pricingIndex) => {
                let licences, previousUpto;
                if (pricingIndex === 0) {
                    licences = pricing.up_to === 'inf' ? quantity : pricing.up_to;
                } else {
                    previousUpto = customPricing[pricingIndex - 1]?.up_to ?? 0;
                    licences = pricing.up_to === 'inf' ? (quantity - previousUpto) : (pricing.up_to - previousUpto);
                }
                return {
                    ...pricing,
                    unit_amount: pricing.unit_amount,
                    nbLicences: licences
                }
            });
        },
    }
}
